import __request__ from "routing/request";
export function createCollector(JSONbody, requestOptions) {
  return __request__("POST", "/sidecar/collectors", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function listCollectors(requestOptions) {
  return __request__("GET", "/sidecar/collectors", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function listSummary(sort = "name", page = 1, per_page = 50, query, order = "asc", requestOptions) {
  return __request__("GET", "/sidecar/collectors/summary", null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function validateCollector(collector, requestOptions) {
  return __request__("POST", "/sidecar/collectors/validate", collector, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getCollector(id, requestOptions) {
  return __request__("GET", `/sidecar/collectors/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function updateCollector(id, JSONbody, requestOptions) {
  return __request__("PUT", `/sidecar/collectors/${id}`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function deleteCollector(id, requestOptions) {
  return __request__("DELETE", `/sidecar/collectors/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function copyCollector(id, name, requestOptions) {
  return __request__("POST", `/sidecar/collectors/${id}/${name}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
